import { axiosAuth } from "../../config/axiosInstances";

export function getUserNotes(lesson_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:ltai_router/notes",
        {
          params: {
            lesson_id,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function generateUserAiNote(
  lesson_id,
  langauge,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:ltai_router/notes/generate",
        {
          params: {
            lesson_id,
            langauge,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function EditUserNote(
  user_ai_notes_id,
  notes,
  visibility,
  langauge,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:ltai_router/notes/edit",
        {
          user_ai_notes_id,
          notes,
          visibility,
          langauge,
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function resetUserAiNote(
    user_ai_notes_id,
    successCallback,
    errorCallback
  ) {
    return async function (dispatch) {
      try {
        const response = await axiosAuth.post(
          "https://xgfy-czuw-092q.m2.xano.io/api:ltai_router/notes/reset",
          {
            user_ai_notes_id
          }
        );
  
        successCallback && successCallback(response.data);
      } catch (err) {
        console.log(err);
        errorCallback && errorCallback(err);
      }
    };
  }
  

  export function createUserNote(
   lesson_id,
   langauge,
   notes,
   visibility,
   successCallback,
   errorCallback
  ) {
    return async function (dispatch) {
      try {
        const response = await axiosAuth.post(
          "https://xgfy-czuw-092q.m2.xano.io/api:ltai_router/notes/custom/create",
          {
            lesson_id,
            langauge,
            notes,
            visibility
          }
        );
  
        successCallback && successCallback(response.data);
      } catch (err) {
        console.log(err);
        errorCallback && errorCallback(err);
      }
    };
  }


  export function deleteUserNote(
    user_ai_notes_id,
    successCallback,
    errorCallback
   ) {
     return async function (dispatch) {
       try {
         const response = await axiosAuth.delete(
           "https://xgfy-czuw-092q.m2.xano.io/api:ltai_router/notes/custom/delete",{
           params : {
            user_ai_notes_id
           }
          }
         );
   
         successCallback && successCallback(response.data);
       } catch (err) {
         console.log(err);
         errorCallback && errorCallback(err);
       }
     };
   }

   export function getOtherLearnerNotes(
    lesson_id,
    successCallback,
    errorCallback
   ) {
     return async function (dispatch) {
       try {
         const response = await axiosAuth.get(
           "https://xgfy-czuw-092q.m2.xano.io/api:ltai_router/notes/other_learner_notes",{
           params : {
            lesson_id
           }
          }
         );
   
         successCallback && successCallback(response.data);
       } catch (err) {
         console.log(err);
         errorCallback && errorCallback(err);
       }
     };
   }


   export function likeUserNote(
    user_ai_notes_id,
    successCallback,
    errorCallback
   ) {
     return async function (dispatch) {
       try {
         const response = await axiosAuth.post(
           "https://xgfy-czuw-092q.m2.xano.io/api:ltai_router/notes/other_learner_notes/like",{
            user_ai_notes_id
  
          }
         );
   
         successCallback && successCallback(response.data);
       } catch (err) {
         console.log(err);
         errorCallback && errorCallback(err);
       }
     };
   }

   export function shareAiNote(
    ai_user_notes_id,
    qr_link,
    successCallback,
    errorCallback
   ) {
     return async function (dispatch) {
       try {
         const response = await axiosAuth.get(
           "https://xgfy-czuw-092q.m2.xano.io/api:xforge/generate/shareable/notes",{
            params : {
              ai_user_notes_id,
              qr_link
            }
  
          }
         );
   
         successCallback && successCallback(response.data);
       } catch (err) {
         console.log(err);
         errorCallback && errorCallback(err);
       }
     };
   }

   export function shareUserLearnings(
    lesson_id,
    qr_link,
    successCallback,
    errorCallback
   ) {
     return async function (dispatch) {
       try {
         const response = await axiosAuth.get(
           "https://xgfy-czuw-092q.m2.xano.io/api:xforge/generate/shareable/learning",{
            params : {
              lesson_id,
              qr_link
            }
  
          }
         );
   
         successCallback && successCallback(response.data);
       } catch (err) {
         console.log(err);
         errorCallback && errorCallback(err);
       }
     };
   }